import React, { useState } from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png";
import CommitteeCard from "../../components/CommitteeCard/CommitteeCard";
import chiefPatron from "../../assets/images/chiefPatron.png";
import patron2 from "../../assets/images/director.jpg";
import patron1 from "../../assets/images/Patron1.jpg";
import copatron1 from "../../assets/images/CoPatron1.jpeg";
import copatron2 from "../../assets/images/CoPatron2.jpeg";
import copatron3 from "../../assets/images/CoPatron3.jpg";
import confChair from "../../assets/images/ConfChair1.jpeg";
import ConfCoChair1 from "../../assets/images/ConfCoChair1.jpeg";
import ConfCoChair2 from "../../assets/images/ConfCoChair2.jpeg";
import ConfCoChair3 from "../../assets/images/ConfCoChair.jpg";
import OrgSecy1 from "../../assets/images/OrgSecy1.jpeg";
import OrgSecy2 from "../../assets/images/OrgSecy2.jpeg";
import JointOrgsecy1 from "../../assets/images/JointOrgSecy1.jpeg";
import JointOrgsecy2 from "../../assets/images/JointOrgSecy2.jpeg";
import JointOrgsecy3 from "../../assets/images/JointOrgSecy3.jpeg";
import JointOrgsecy4 from "../../assets/images/VarunSinghal.jpeg";
import treasurer from "../../assets/images/treasurer.jpeg";
import Layout from "../../components/Layout/layout";
import chiefPatron2 from "../../assets/images/chiefPatron2.jpg";
import civilhead from "../../assets/images/image.png";

const CommitteePage = () => {
  return (
    <Layout>
      <main className="pt-[10vw]">
        <div className="flex absolute md:mt-[-20vw] mt-[-5vw] md:flex-row flex-col items-center w-full justify-center gap-12">
          <div
            className="text-[55px] text-white"
            style={{ fontFamily: "Bebas Neue", textShadow: "2px 1px 0px #000" }}
          >
            ORGANIZING COMMITTEE
          </div>
        </div>
        <div className="px-20 py-32 border-2 my-10 mx-auto bg-white flex flex-col items-center gap-52 justify-between">
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Chief Patron
            </span>
            <CommitteeCard
              img={chiefPatron2}
              name="Prof. Shamsher Prakash"
              por=""
            />
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Patrons
            </span>
            <div className="flex flex-row items-center gap-12 flex-wrap">
              <CommitteeCard
                img={patron2}
                name="Prof. Devendra Jalihal"
                por="Director, IIT Guwahati"
              />
              <CommitteeCard
                img={patron1}
                name="Prof. Kamal Kishore Pant"
                por="Director, IIT Roorkee"
              />
            </div>
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Co-Patrons
            </span>
            <div className="flex flex-row items-center gap-12 flex-wrap">
              <CommitteeCard
                img={civilhead}
                name="Prof. Rajib Kumar Bhattacharjya"
                por="Head, Civil Engg, IIT Guwahati"
              />
              <CommitteeCard
                img={copatron2}
                name="Prof Manish Shrikhande"
                por="Head EQ. Engg., IIT Roorkee"
              />
              <CommitteeCard
                img={copatron3}
                name="Prof. Hemant B. Kaushik"
                por="Chair ISET, Guwahati Chapter"
              />
            </div>
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Conference Chair
            </span>
            <CommitteeCard
              img={confChair}
              name="Prof. B K Maheshwari"
              por="President ISET"
            />
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Conference Co-Chairs
            </span>
            <div className="flex flex-row items-center gap-12 flex-wrap">
              <CommitteeCard
                img={ConfCoChair3}
                name="Prof. Sebastiano Foti"
                por="Politecnico di Torino (Rep. ISSMGE TC 203)"
              />
              <CommitteeCard
                img={ConfCoChair2}
                name="Prof. Madhavi Latha G."
                por="IISc Bangalore"
              />
              <CommitteeCard
                img={ConfCoChair1}
                name="Prof. Ravi Jakka"
                por="IIT Roorkee"
              />
            </div>
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Organizing Secretaries
            </span>
            <div className="flex flex-row items-center gap-12 flex-wrap">
              <CommitteeCard
                img={OrgSecy1}
                name="Prof. Abhishek Kumar"
                por="IIT Guwahati"
              />
              <CommitteeCard
                img={OrgSecy2}
                name="Prof. Rajib Sarkar"
                por="IIT Dhanbad"
              />
            </div>
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Joint Organizing Secretaries
            </span>
            <div className="flex flex-row items-center gap-12 flex-wrap">
              <CommitteeCard
                img={JointOrgsecy1}
                name="Prof. Ravi K"
                por="IIT Guwahati"
              />
              <CommitteeCard
                img={JointOrgsecy2}
                name="Prof. Anil K. Mishra"
                por="IIT Guwahati"
              />
              <CommitteeCard
                img={JointOrgsecy3}
                name="Prof. Sanket Nayak"
                por="IIT Dhanbad"
              />
              <CommitteeCard
                img={JointOrgsecy4}
                name="Prof. Varun Singla"
                por="IIT Roorkee"
              />
            </div>
          </div>
          <div className="flex flex-col items-center gap-10">
            <span
              className="text-[#1F7E95] text-[55px]"
              style={{ fontFamily: "Bebas Neue" }}
            >
              Treasurer
            </span>
            <CommitteeCard
              img={treasurer}
              name="Prof. P C Ashwin Kumar"
              por="IIT Roorkee (Secretary ISET)"
            />
          </div>
        </div>
      </main>
    </Layout>
  );
};
export default CommitteePage;
